<template>
  <div class="cursos">
    <Header/>
      <div class="body">
        <div class="sobre">
          <h2> <font-awesome-icon icon="book" class="icon_spot"/> Cursos Extensivos </h2> <br>
          <div>
            <b-tabs content-class="mt-3" fill><!--
              <b-tab title="SAPI MUNDO" active><p>
                <div class="div_tam">
                  <h4 class="p_sobre">Sapi Mundo</h4>
                  <p class="p_sobre"> Já pensou em personalizar o seu ano de cursinho pensando no que você tem mais dificuldade? Venha para o Sapi Mundo e tenha acesso a tudo o que o Sapi pode te disponibilizar: plantões, aulas tradicionais, aulas PBL, aulas modulares, Projeto Canguru, Projeto Self e simulados personalizados quinzenais. E mais: auxílio completo com o nosso simulador do SISU e aulas até janeiro preparatórias para as segundas fases e vestibular UNILUS.</p>
                </div>
              </b-tab>-->
              <b-tab title="SAPI SUPREMO">
                <div class="div_tam">
                  <h4 class="p_sobre">Sapi Supremo</h4>
                  <p class="p_sobre">O único cursinho integral de verdade na Baixada Santista. Perfeito pra você que tem lacunas escolares e quer sanar todas as suas dificuldades com os nossos plantões, aulas tradicionais e aulas PBL. Você acha que não se organiza sozinho? Nossa equipe está pronta para acompanhar seus estudos individualmente por meio do Projeto Canguru, do Projeto Self e dos nossos simulados personalizados quinzenais. Conte conosco também para o auxílio com o nosso simulador do SISU. </p>
                </div>
              </b-tab>
              <b-tab title="SAPI PRIME">
                <div class="div_tam">
                  <h4 class="p_sobre">Sapi Prime</h4>
                   <p class="p_sobre">Você já imaginou poder montar a sua própria grade horária do cursinho pré-vestibular? Pois aqui você pode! O Sapi Prime possibilita que você decida como e quando estudar, com todas as disciplinas disponíveis, o curso é dinâmico e dá a oportunidade de você desenvolver os seus interesses. Quer fazer somente disciplinas que você tem dificuldade? Sem problemas. Quer fazer aquelas que tem peso na nota final do seu curso? Também pode. Quer fazer tudo e construir um cursinho completo mais flexível? Sem estresse. Corre e vem ser SAPI PRIME.</p>
                </div>
              </b-tab><!--
              <b-tab title="SAPI NOTURNO">
                <div class="div_tam">
                  <h4 class="p_sobre">Sapi Noturno</h4>
                   <p class="p_sobre">O pré-vestibular noturno mais completo da Baixada Santista: veja TODO o conteúdo do Ensino Médio antes do ENEM, incluindo nossas tradicionais aulas de Redação, História da Arte e Filosofia!! E mais: acesso aos nossos simulados com rendimento no Aplicativo Sapiência. Além disso, todo o auxílio de janeiro está incluído para você: aulas para segundas fases e UNILUS e suporte no nosso simulador do SISU.</p>
                </div>
              </b-tab>-->
            </b-tabs>
          </div>
          <h5 class="msgs">Ligue e conheça nossa metodologia (13) 3877-0073 ou envie uma mensagem no Whatsapp (13) 99749-9702</h5><br>
        </div>
    </div>
  <Footer/>
  </div>
</template>


<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
  components: {
    Header,
    Footer
  }
}
</script>

<style>
@import "../assets/style_padrao.css";
  #t{
    position: absolute;
    left: 35%;
    bottom: 75%;
    z-index: 1000;
    background: #7435af;
    margin: auto;
    border-radius: 20px;
    padding: 2% 5%;
    width: fit-content;
  }
  #a{
    position: relative;
    padding-top: 7%;
    border-radius: 25px;
    background:white;
    box-shadow: 2px 3px 18px #adadad;
  }
  #sap_aluno{
    width: 100%;
    margin-bottom: 5%;
  }
  .cursos{
    width: 100%;
    height: auto;
  }
  h1{
    text-align: center;
  }
  h2{
    text-align: center;
  }
  .p_sobre{
    margin-left: 4%;
    margin-right: 4%;
    text-align: justify!important;
    color: #4F4F4F;
    line-height: 1.8;
  }
  #msg{
    text-align: center;
  }
  @media only screen and (max-width: 450px) {
    .p_sobre{
      line-height: 1.8;
      text-align:left!important;
    }
  }
</style>
